import React, { useEffect, useState } from "react";
import api from "../../api/axiosConfig";
import NavbarMenu from "../../components/NavbarMenu";

/* ===============================
   NORMALIZAR (BLINDADO)
================================ */
const normalizar = (v) =>
  String(v ?? "")
    .toUpperCase()
    .trim();

export default function MenuDigital() {
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoriasAbiertas, setCategoriasAbiertas] = useState([]);

  /* ===============================
     CARGA DE MENÚ
  ================================ */
  useEffect(() => {
    let alive = true;

    async function cargarMenu() {
      try {
        const res = await api.get("/public/productos");
        const data = res.data || [];

        if (!alive) return;

        setProductos(data);

        /* ===============================
           🔥 CATEGORÍAS ÚNICAS + ORDEN
        ================================ */
        const categoriasMap = new Map();

        data.forEach((p) => {
          if (p.categoria?.id) {
            categoriasMap.set(p.categoria.id, p.categoria);
          }
        });

        const categoriasOrdenadas = Array.from(
          categoriasMap.values()
        ).sort((a, b) => {
          // orden = 0 al final
          if (a.orden === 0) return 1;
          if (b.orden === 0) return -1;
          return (a.orden ?? 0) - (b.orden ?? 0);
        });

        setCategorias(categoriasOrdenadas);
        setCategoriasAbiertas([]);
      } catch (e) {
        console.error("Error cargando menú", e);
      } finally {
        if (alive) setLoading(false);
      }
    }

    cargarMenu();
    return () => {
      alive = false;
    };
  }, []);

  /* ===============================
     TOGGLE CATEGORÍA
  ================================ */
  const toggleCategoria = (catNombre) => {
    setCategoriasAbiertas((prev) =>
      prev.includes(catNombre)
        ? prev.filter((c) => c !== catNombre)
        : [...prev, catNombre]
    );
  };

  /* ===============================
     LOADING
  ================================ */
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-orange-400 text-xl">
        Cargando menú...
      </div>
    );
  }

  return (
    <section className="min-h-screen bg-black text-white">
      <NavbarMenu />

      <div className="pt-28 px-6 pb-28 max-w-5xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold text-orange-400 text-center">
          🍽️ Nuestro Menú
        </h1>

        {/* ===============================
            CATEGORÍAS
        ================================ */}
        <div className="space-y-4">
          {categorias.map((cat) => {
            const abierta = categoriasAbiertas.includes(cat.nombre);

            return (
              <div
                key={cat.id}
                className="bg-[#0f0f0f] rounded-xl border border-white/10 overflow-hidden"
              >
                {/* HEADER */}
                <button
                  onClick={() => toggleCategoria(cat.nombre)}
                  className="w-full px-4 py-3 flex justify-between items-center
                             text-lg font-semibold text-orange-400
                             hover:bg-white/5 transition"
                >
                  <span>{cat.nombre}</span>
                  <span
                    className={`transition-transform ${
                      abierta ? "rotate-180" : ""
                    }`}
                  >
                    ⌄
                  </span>
                </button>

                {/* PRODUCTOS */}
                {abierta && (
                  <div className="px-4 pb-4 space-y-4">
                    {productos
                      .filter(
                        (p) =>
                          normalizar(
                            p.categoria?.nombre
                          ) === normalizar(cat.nombre)
                      )
                      .map((p, index, arr) => {
                        const noDisponible =
                          p.bloqueado === true ||
                          p.categoria?.activo === false;

                        return (
                          <div key={p.id}>
                            <article
                              className={`space-y-1 transition ${
                                noDisponible
                                  ? "opacity-50 grayscale"
                                  : ""
                              }`}
                            >
                              <div className="flex justify-between items-start gap-3">
                                <span className="font-medium text-sm flex items-center gap-2">
                                  {p.nombre}

                                  {noDisponible && (
                                    <span className="text-xs bg-red-600 text-white px-2 py-0.5 rounded-full">
                                      No disponible
                                    </span>
                                  )}
                                </span>

                                <span className="text-orange-400 font-semibold text-sm">
                                  $
                                  {Number(p.precio).toLocaleString(
                                    "es-CO"
                                  )}
                                </span>
                              </div>

                              {p.ingredientes && (
                                <p className="text-xs text-gray-400 leading-relaxed">
                                  <span className="font-semibold text-orange-300">
                                    Ingredientes:
                                  </span>{" "}
                                  {p.ingredientes}
                                </p>
                              )}
                            </article>

                            {index < arr.length - 1 && (
                              <div className="h-px bg-white/10 my-4"></div>
                            )}
                          </div>
                        );
                      })}

                    {productos.filter(
                      (p) =>
                        normalizar(
                          p.categoria?.nombre
                        ) === normalizar(cat.nombre)
                    ).length === 0 && (
                      <p className="text-gray-400 text-sm">
                        No hay productos en esta categoría
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
